module.exports = __webpack_public_path__ + "img/slider_comments_4.0df15482.jpg";